<template>
  <a-modal
    v-model="showModal"
    :title="`Remove ${roleName} from Referral program`"
    :footer="null"
    width="500px"
    :destroyOnClose="true"
    class="remove-user-modal"
  >
    <div class="mb-3">
      <span class="font-size-16">This will permanently delete:</span>
      <ul>
        <li
          v-for="(consequence, index) in consequencesOfRemoval"
          :key="index"
        >
          <span :class="{'font-weight-bold' : consequence.bold}">{{ consequence.text }}</span>
        </li>
      </ul>
      <span class="d-flex align-items-center font-weight-bold font-size-16"><a-icon class="d-flex text-danger mr-2" type="info-circle" /> This action cannot be undone.</span>
    </div>
    <a-form-model ref="removeUserForm" :model="form">
      <a-form-model-item
        label="Reason for removal"
        required
        prop="reason"
        :colon="false"
        :rules="[{ required: true, message: 'Reason is required', trigger: ['change'] }]"
      >
        <a-textarea
          v-model="form.reason"
          size="large"
          class="w-full"
          placeholder="Reason for removal"
          :auto-size="{ minRows: 2, maxRows: 6 }"
          :disabled="loading"
        />
      </a-form-model-item>
      <a-row class="footer-viewscreen footer">
        <div class="d-flex justify-content-end w-full">
          <a-button
            :loading="loading"
            @click="closeModal"
          >
            Cancel
          </a-button>
          <a-button
            type="danger"
            class="ml-2"
            :loading="loading"
            @click="onSubmit"
          >
            Remove
          </a-button>
        </div>
      </a-row>
    </a-form-model>
  </a-modal>
</template>

<script>
import apiClient from '@/services/axios'
import { handleNumberKeyPress } from '@/views/apps/referral-program/composables/useHandleNumberKeyPress.js'
import { capitalizeFirstLetter } from '@/composables/useCapitalizeFirstLetter.js'
import { getErrorMessage } from '@/views/apps/fortune-wheel/composables/useGetErrorMessage.js'

const referralApiUrl = process.env.VUE_APP_REFERRAl_API_URL
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  components: {
  },
  data: () => ({
    form: {
      reason: '',
    },
    showModal: false,
    loading: false,
  }),
  watch: {
    show: {
      handler(val) {
        if (val) {
          this.showModal = true
        } else {
          this.showModal = false
        }
      },
      deep: true,
      immediate: true,
    },
    showModal: {
      handler(val) {
        if (!val) {
          this.closeModal()
        }
      },
      deep: true,
    },
  },
  computed: {
    roleName() {
      return capitalizeFirstLetter(this.$route.params.role)
    },
    isAffiliate() {
      return this.$route.params.role === 'affiliate'
    },
    consequencesOfRemoval() {
      if (this.isAffiliate) {
        return [
          { text: 'Affiliate`s participation in the referral program', bold: false },
          { text: 'Their referral progress', bold: false },
          { text: 'All users referred by this affiliate', bold: true },
        ]
      }
      return [
        { text: 'Referral`s participation in the referral program', bold: false },
        { text: 'Their referral progress', bold: false },
      ]
    },
  },
  methods: {
    keyPressInputNumber(event, allowDot = true) {
      handleNumberKeyPress(event, allowDot)
    },
    onSubmit() {
      this.$refs.removeUserForm.validate(async (valid) => {
        if (valid) {
          this.removeUser()
        } else {
          return false
        }
      })
    },
    async removeUser() {
      try {
        this.loading = true

        const programId = this.$route.params.id
        const role = this.$route.params.role
        const memberId = this.$route.params.member_id

        const url = `${referralApiUrl}/referral-programs/${programId}/members/${role}/${memberId}`
        const response = await apiClient.delete(url, {
          params: { reason: this.form.reason },
        })
        if (response?.status >= 200 && response?.status < 300) {
          this.$notification.success({
            message: 'User successfully removed',
          })
          this.closeModal()
          this.$router.push(`/referral/programs/${programId}/members`)
          return
        }
        getErrorMessage(response?.data)
        return null
      } catch (e) {
        this.$notification.error({
          message: e?.message ? e.message : 'Error',
        })
      } finally {
        this.loading = false
      }
    },
    closeModal() {
      this.$emit('close')
      setTimeout(() => {
        this.form.reason = ''
      }, 500)
    },
  },
}
</script>

<style lang="scss">
.remove-user-modal {
  ul {
    padding-left: 30px;
  }
  .footer {
    display: flex;
    justify-content: space-between;
    &::before,
    &::after {
      content: none;
    }
  }
}
</style>
